import { useParams } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import MovieCard from '@/components/feature/MovieCard';
import CategoryTabs from '@/components/feature/CategoryTabs';
import { movies, categories } from '@/mocks/movies';

const categoryNames: Record<string, string> = {
  movie: '电影',
  tv: '电视剧',
  anime: '动漫',
  variety: '综艺',
};

const categoryDescriptions: Record<string, string> = {
  movie: '哈哈影院高清免费电影频道，汇集最新热门大片、经典老片、高分佳作，涵盖动作、科幻、喜剧、爱情等全类型，播放流畅不缓冲，满足您的在线观影需求。',
  tv: '哈哈影院高清免费电视剧频道，提供热播剧集、经典好剧、最新上线电视剧，涵盖古装、都市、悬疑、爱情等全类型，更新迅速追剧不等待。',
  anime: '哈哈影院高清免费动漫频道，汇集国产动漫、日本动漫等优质动画内容，热血、奇幻、搞笑全类型覆盖，高清画质流畅播放。',
  variety: '哈哈影院高清免费综艺频道，提供热门综艺节目在线观看，涵盖音乐竞演、真人秀、脱口秀等，精彩不断欢乐不停。',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const catName = categoryNames[slug || ''] || '分类';
  const catDesc = categoryDescriptions[slug || ''] || '浏览哈哈影院精彩影视内容。';
  const items = movies.filter((m) => m.category === slug);

  return (
    <>
      <SEOHead
        title={`${catName} - 哈哈影院高清免费${catName}在线观看 | 哈哈影院`}
        description={catDesc}
        keywords={`哈哈影院,哈哈影院${catName},哈哈影院免费${catName},${catName}在线观看,免费${catName}在线看`}
        canonicalUrl={`https://hahacinema.com/category/${slug}`}
        ogTitle={`${catName} - 哈哈影院高清免费${catName}在线观看`}
        ogDescription={catDesc}
        schemaJson={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: `哈哈影院${catName}频道`,
          description: catDesc,
          url: `https://hahacinema.com/category/${slug}`,
          isPartOf: {
            '@type': 'WebSite',
            name: '哈哈影院',
            url: 'https://hahacinema.com/',
          },
        }}
      />
      <Navbar />
      <main className="min-h-screen pt-16">
        <Breadcrumb />
        <section className="px-4 md:px-6 py-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
            <div>
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                {catName}
              </h1>
              <p className="text-sm text-foreground-500 mt-1">{catDesc}</p>
            </div>
            <CategoryTabs />
          </div>

          {items.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5" data-product-shop>
              {items.map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <i className="ri-movie-line text-5xl text-foreground-300 w-12 h-12 flex items-center justify-center mx-auto mb-4"></i>
              <p className="text-foreground-500">暂无内容，敬请期待</p>
            </div>
          )}
        </section>
      </main>
      <Footer />
    </>
  );
}